<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="participants"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Оролцогчид ({{ participants.length }}) </v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-dialog
            v-model="dialogEdit"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Бүртгэл+
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Оролцогч нэмэx</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.name"
                        label="Нэр"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.lastName"
                        label="Овог"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.register"
                        label="Регистр"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.phone"
                        label="Утасны дугаар"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeEdit"
                >
                  Цуцлаx
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="addItem"
                >
                  Xадгалаx
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar> 
      </template>
      <template
        slot="item.idd"
        scope="props"
      >
        {{ props.index + 1 }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click.stop="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click.stop="editItem(item)"
        >
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn @click="_initialize">
          Шинэчлэx
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogDelete"
      max-width="20%"
      scrollable
    >
      <v-card>
        <v-card-title
          class="headline"
        >
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDelete"
          >
            Цуцлаx
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style>
.v-ripple__container {
  display: none !important;
}
</style>
<script>

  const fb = require('../../firebaseConfig.js')
  export default {
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        // return value.charAt(0).toUpperCase() + value.slice(1)
        return value.toUpperCase()
      },
    },
    props: {
      asuulgaId: {
        type: String,
        required: false,
      },
    },
    data: () => ({
      color: '#ccc',
      participants: [],
      dialogEdit: false,
      dialogDelete: false,
      headers: [
        { text: 'ID', value: 'idd' },
        {
          text: 'Нэр',
          align: 'start',
          sortable: false,
          value: 'name',
          class: "primary--text font-weight-regular",
        },
        {
          text: 'Овог',
          align: 'start',
          sortable: false,
          value: 'lastname',
          class: "primary--text font-weight-regular",
        },
        { text: 'Регистр', value: 'register', class: "primary--text font-weight-regular" },
        { text: 'Утасны дугаар', value: 'phone', class: "primary--text font-weight-regular" },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        lastname: '',
        register: '',
        phone: '',
      },
      defaultItem: {
        name: '',
        lastname: '',
        register: '',
        phone: '',
      },
    }),
    watch: {
    },
    created() {
      this.participants = []
      this._initialize()
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.participants.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogEdit = true
      },
      deleteItem(item) {
        this.editedIndex = this.participants.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      // fb.db.collection("asuulga/" + this.asuulgaId + "/users").doc(item.id);
      },
      deleteItemConfirm() {
        // this.participants.splice(this.editedIndex, 1);
        var deleteItem = this.participants[this.editedIndex]
        if (deleteItem) {
          fb.db.collection('asuulga/' + this.asuulgaId + '/users').doc(deleteItem.id).delete()
        }
        this.closeDelete()
      },
 
      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeEdit() {
        this.dialogEdit = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      addItem() {
        console.log(this.editedIndex)
        var docRef
        this.editedItem.createdAt = new Date()
        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          docRef = fb.db.collection("asuulga/" + this.asuulgaId + "/users/").doc()
        } else {
          docRef = fb.db.collection("asuulga/" + this.asuulgaId + "/users/").doc(this.editedItem.id)
        }
        docRef.set(this.editedItem)
        console.log(this.editedItem)
        this.closeEdit()
      },
      async _initialize() {
        fb.db
          .collection('asuulga/' + this.asuulgaId + '/users')
          .orderBy('createdAt', 'asc')
          .onSnapshot((querySnapshot) => {
            this.participants = []
            querySnapshot.forEach(async (userDoc) => {
              const user = userDoc.data()
              user.id = userDoc.id
              user.ref = userDoc.ref
              var datas = await userDoc.ref.collection('answered').orderBy('createdAt', 'desc').limit(1).get()
              if (!datas.empty) {
                var userObj = datas.docs[0]
                if (userObj != null && userObj.exists) {
                  user.allScore = userObj.data().allScore
                  user.allScored = userObj.data().allScored
                  user.endedAt = new Date(userObj.data().createdAt.toDate())
                }
              }
              this.participants.push(user)
            })
          })
      },
    },
  }
</script>
